import React from 'react';
import {
  Amex,
  Discover,
  MasterCard,
  PayPal,
  Visa,
  ApplePay,
} from '@fff-web/fff-ui-shared/Icon';
import styles from './scss/PaymentFormContainer.module.scss';
import { useAppContext } from '../../../../utils/ContextProviders/AppContext';
import { viewSizes } from '../../../../hooks/useViewSize';

const GREY = '#9b9b9b';

const PaymentIcons: React.FunctionComponent = () => {
  const { viewSize } = useAppContext();

  if (viewSize === viewSizes.extraSmall || viewSize === viewSizes.small) {
    return null;
  }

  return (
    <>
      <div className={styles.paymentIcon}>
        <Visa fill={GREY} />
      </div>
      <div className={styles.paymentIcon}>
        <MasterCard fill={GREY} />
      </div>
      <div className={styles.paymentIcon}>
        <Amex fill={GREY} />
      </div>
      <div className={styles.paymentIcon}>
        <Discover fill={GREY} />
      </div>
      <div className={styles.paymentIcon}>
        <PayPal fill={GREY} />
      </div>
      <div className={styles.paymentIcon}>
        <ApplePay fill={GREY} />
      </div>
    </>
  );
};

export default PaymentIcons;
